// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var WarningType;
(function (WarningType) {
    WarningType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    WarningType["REVIEW_SOURCE_ERROR"] = "REVIEW_SOURCE_ERROR";
    WarningType["REVIEW_SOURCE_TIMEOUT_ERROR"] = "REVIEW_SOURCE_TIMEOUT_ERROR";
    WarningType["AUTHORIZATION_ERROR"] = "AUTHORIZATION_ERROR";
})(WarningType || (WarningType = {}));
export var WarningType_index;
(function (WarningType_index) {
    WarningType_index[WarningType_index["UNKNOWN_ERROR"] = 0] = "UNKNOWN_ERROR";
    WarningType_index[WarningType_index["REVIEW_SOURCE_ERROR"] = 1] = "REVIEW_SOURCE_ERROR";
    WarningType_index[WarningType_index["REVIEW_SOURCE_TIMEOUT_ERROR"] = 2] = "REVIEW_SOURCE_TIMEOUT_ERROR";
    WarningType_index[WarningType_index["AUTHORIZATION_ERROR"] = 3] = "AUTHORIZATION_ERROR";
})(WarningType_index || (WarningType_index = {}));
export var ReviewSource;
(function (ReviewSource) {
    ReviewSource["FACEBOOK"] = "FACEBOOK";
    ReviewSource["GOOGLE"] = "GOOGLE";
    ReviewSource["PRIVATE"] = "PRIVATE";
})(ReviewSource || (ReviewSource = {}));
export var ReviewSource_index;
(function (ReviewSource_index) {
    ReviewSource_index[ReviewSource_index["FACEBOOK"] = 0] = "FACEBOOK";
    ReviewSource_index[ReviewSource_index["GOOGLE"] = 1] = "GOOGLE";
    ReviewSource_index[ReviewSource_index["PRIVATE"] = 2] = "PRIVATE";
})(ReviewSource_index || (ReviewSource_index = {}));
export const ReviewsAggregatorService = {
    GetAggregatedReviews(fn, req) {
        return fn(`/reviews/aggregator/v1/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetReviewsMappings(fn, req) {
        return fn(`/reviews/aggregator/v1/mappings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
